import { Component, OnInit } from '@angular/core';
import {NewNavigationService} from "@shared/services/new-navigation.service";

@Component({
  selector: 'app-set-new-password-confirmation',
  templateUrl: './set-new-password-confirmation.component.html',
  styles: []
})
export class SetNewPasswordConfirmationComponent implements OnInit {

  constructor(private navigationService: NewNavigationService) { }

  ngOnInit(): void {
  }

  onClick() {
    this.navigationService.toLogin();
  }
}
